import React from "react";

interface RulerProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  color?: string;
  title?: string;
}

export const Ruler: React.FC<RulerProps> = ({
  className = "",
  width = 57.18,
  height = 30.91,
  color = "#383838",
  title = "Ruler",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 57.18 30.91"
      className={`sg-link-icon ${className}`}
      aria-labelledby="rulerTitle"
      role="img"
    >
      {title && <title id="rulerTitle">{title}</title>}
      <defs>
        <style>
          {`.cls-1{fill:#d0cbbf}.cls-2{fill:#fff}.cls-4{fill:${color}}`}
        </style>
      </defs>
      <g id="Lager_1">
        <path
          d="M36.61 21.89c0 .98-.35 1.91-1 2.77-2.45 3.3-9.15 5.68-17.02 5.68S4.01 27.97 1.57 24.66c-.64-.86-1-1.8-1-2.77V9.03H36.6v12.86z"
          className="cls-1"
        />
        <path
          d="M18.6 30.91c-7.85 0-14.87-2.37-17.48-5.91C.38 24.01 0 22.96 0 21.89V8.46h37.18v5.46h-1.15V9.61H1.15V21.9c0 .82.3 1.64.88 2.43 2.41 3.26 9.06 5.44 16.56 5.44s14.14-2.19 16.56-5.44c.59-.79.88-1.61.88-2.43h1.15c0 1.07-.37 2.12-1.11 3.11-2.62 3.53-9.65 5.91-17.48 5.91z"
          className="cls-4"
        />
        <ellipse cx="18.59" cy="9.02" className="cls-2" rx="18.02" ry="8.45" />
        <path
          d="M18.59 18.04C8.17 18.04 0 14.08 0 9.02S8.17 0 18.59 0s18.59 3.96 18.59 9.02-8.17 9.02-18.59 9.02zm0-16.89c-9.45 0-17.44 3.6-17.44 7.87s7.99 7.87 17.44 7.87 17.44-3.61 17.44-7.87-7.98-7.87-17.44-7.87z"
          className="cls-4"
        />
        <path
          d="M26.46 7.39c.47.5.73 1.05.73 1.63 0 2.23-3.85 4.03-8.6 4.03s-8.6-1.81-8.6-4.03 3.85-4.03 8.6-4.03c1.58 0 3.05.2 4.32.55l3.54 1.85z"
          className="cls-2"
        />
        <path
          d="M18.59 13.63c-5.14 0-9.18-2.02-9.18-4.61s4.03-4.61 9.18-4.61c1.57 0 3.12.2 4.48.57l-.3 1.11c-1.26-.34-2.7-.53-4.17-.53-4.73 0-8.03 1.82-8.03 3.46s3.3 3.46 8.03 3.46 8.03-1.82 8.03-3.46c0-.42-.19-.83-.58-1.24l.83-.79c.58.62.89 1.32.89 2.03 0 2.58-4.03 4.61-9.18 4.61z"
          className="cls-4"
        />
        <path
          d="M18.59 30.34h37.6c.22 0 .41-.18.41-.41V17.88c0-.22-.18-.41-.41-.41h-37.6v12.87z"
          className="cls-1"
        />
        <path
          d="M56.2 30.91H18.59v-1.15h37.44V18.04H18.59v-1.15h37.6c.54 0 .98.44.98.98v12.05c0 .54-.44.98-.98.98z"
          className="cls-4"
        />
        <path
          d="M52.87 22.55v7.78c0 .7 1.09.7 1.09 0v-7.78c0-.7-1.09-.7-1.09 0zm-3.18 3.89v3.89c0 .7 1.09.7 1.09 0v-3.89c0-.7-1.09-.7-1.09 0zm-3.18-3.89v7.78c0 .7 1.09.7 1.09 0v-7.78c0-.7-1.09-.7-1.09 0zm-3.18 3.89v3.89c0 .7 1.09.7 1.09 0v-3.89c0-.7-1.09-.7-1.09 0zm-3.19-3.89v7.78c0 .7 1.09.7 1.09 0v-7.78c0-.7-1.09-.7-1.09 0zm-3.18 3.89v3.89c0 .7 1.09.7 1.09 0v-3.89c0-.7-1.09-.7-1.09 0zm-3.18-3.89v7.78c0 .7 1.09.7 1.09 0v-7.78c0-.7-1.09-.7-1.09 0zm-3.19 3.89v3.89c0 .7 1.09.7 1.09 0v-3.89c0-.7-1.09-.7-1.09 0zm-3.18-3.89v7.78c0 .7 1.09.7 1.09 0v-7.78c0-.7-1.09-.7-1.09 0zm-3.18 3.89v3.89c0 .7 1.09.7 1.09 0v-3.89c0-.7-1.09-.7-1.09 0zm-3.19-3.89v7.78c0 .7 1.09.7 1.09 0v-7.78c0-.7-1.09-.7-1.09 0zm-3.18 3.89v3.89c0 .7 1.09.7 1.09 0v-3.89c0-.7-1.09-.7-1.09 0zM36.07 9.03v5.86c0 .7 1.09.7 1.09 0V9.03c0-.7-1.09-.7-1.09 0z"
          className="cls-4"
        />
        <path
          d="M18.59 5.53c1.42.01 2.81.17 4.18.53.68.18.97-.87.29-1.05-1.46-.38-2.96-.55-4.47-.57-.7 0-.7 1.08 0 1.09zm7.48 2.24c.33.37.55.75.58 1.25.03.7 1.12.7 1.09 0-.04-.8-.37-1.43-.89-2.02-.47-.52-1.24.25-.77.77z"
          style={{ fill: "#474647" }}
        />
      </g>
    </svg>
  );
};
